import React from "react";
import { Card } from "react-bootstrap";
import { getContrastColor } from "utils/utils";

function AgentLevelsSection({ agentLevels }) {
  return (
    <Card
      style={{
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
      className="mb-3"
    >
      <Card.Body className="p-3">
        <h2
          style={{
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          Semua Level
        </h2>

        <small style={{ color: "#6b7280" }}>
          <i>5 Jumlah Agnet Terbanyak pada Rangking</i>
        </small>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "16px",
          }}
          className="agent-grid"
        >
          {agentLevels.map((agent, index) => (
            <Card
              key={agent.id || index}
              style={{
                border: "none",
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                background: agent.color,
                color: getContrastColor(agent.color),
              }}
              className="agent-card"
            >
              <Card.Body
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  padding: "5px",
                  background: "transparent",
                  color: "inherit",
                }}
              >
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  <img
                    src={agent.image || `/rank-${agent.tier}.png`}
                    alt={`${agent.name} icon`}
                    style={{ width: "58px", height: "58px" }}
                  />
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      marginBottom: "4px",
                    }}
                  >
                    {agent.count}
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    {agent.label} - {agent.name}
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

export default AgentLevelsSection;
